import { useQuery } from "@tanstack/react-query";
import { useToasts } from "react-toast-notifications";
import InvoiceStatementService from "services/InvoiceStatementService";

// Danh sách bảng kê. Dùng useQuery vì màn hình cần tự nạp khi mở và khi đổi
// bộ lọc; không qua useQueryCommon vì nhánh onError của nó đọc errorData.code
// mà không kiểm null, sẽ ném TypeError khi lỗi mạng.
export const useStatementList = (params, reloadToken) => {
  const { addToast } = useToasts();

  const query = useQuery({
    // reloadToken chỉ nằm trong queryKey, không đi vào request. Nhờ nó bấm
    // Tìm kiếm lại với đúng bộ lọc cũ vẫn gọi API thay vì lấy từ cache.
    queryKey: ["invoice-statement", "list", params, reloadToken],
    queryFn: () => InvoiceStatementService.listStatements(params),
    retry: 0,
    // Giữ dữ liệu trang cũ khi đang tải trang mới, bảng không bị nháy trắng
    keepPreviousData: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onError: () =>
      addToast("Không tải được danh sách bảng kê", {
        appearance: "error",
        autoDismiss: true,
      }),
  });

  const data = query.data?.data || {};

  return {
    items: data.items || [],
    total: data.total || 0,
    isLoading: query.isFetching,
    refetch: query.refetch,
  };
};
